import type { CustomCellRendererProps } from 'ag-grid-react';

import styles from './ItemListCell.module.scss';

export type TypeItemListCellParams = {
  /**
   * 표기할 필드명
   */
  fieldName: string;
  /**
   * 단위 텍스트
   * @default '건'
   */
  unit?: string;
};

type TypeItemListCellProps<TData, TValue extends Record<string, unknown>[]> = CustomCellRendererProps<TData, TValue> &
  TypeItemListCellParams;

/**
 * 아이템 리스트를 `첫번째 아이템 외 N건` 형태로 표시하는 셀 렌더러
 */
const ItemListCell = <TData, TValue extends Record<string, unknown>[]>({
  value,
  fieldName,
  unit = '건',
}: TypeItemListCellProps<TData, TValue>) => {
  if (!value || value.length === 0) {
    return <div className={styles['item-list-cell']}>{'-'}</div>;
  }

  const firstItem = value[0][fieldName];
  const displayName = !firstItem || typeof firstItem === 'object' ? '-' : String(firstItem);

  return (
    <div className={styles['item-list-cell']}>
      <span className={styles['item-name']}>{displayName}</span>
      {value.length > 1 && <span className={styles['item-count']}>&nbsp;{`외 ${value.length - 1}${unit}`}</span>}
    </div>
  );
};

export default ItemListCell;
